import { render, staticRenderFns } from "./HistoryFishComposition.vue?vue&type=template&id=e2ce675c&scoped=true&"
import script from "./HistoryFishComposition.vue?vue&type=script&lang=js&"
export * from "./HistoryFishComposition.vue?vue&type=script&lang=js&"
import style0 from "./HistoryFishComposition.vue?vue&type=style&index=0&id=e2ce675c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ce675c",
  null
  
)

export default component.exports